import 'core-js/modules/es7.object.values';
import React, { useState, useEffect, useRef } from 'react'
import Draggable from 'react-draggable'
import AddModal from './add-modal'
import ModalManager from '../modal/modal-manager'
import StepRecorder from '../../guide/step-recorder'
import styles from './StepEditor.scss'
import steps from './steps'
import { getGuide, saveGuide } from '../../api/guide'

{/*
  父组件主要方法：
  
    handleCallback接收子组件回调参数：
      item：子组件返回的选择对象
      action：父组件发起的动作：添加(add)、编辑(edit)、插入(insert)
      editIndex：插入、修改时用于定位

    handleAddOrEdit按钮绑定动作：
      发起添加(add)、编辑(edit)、插入(insert)事件
      调用ModalManager向子组件注册属性 --> onConfirm回调函数、modalAction发起动作、editIndex编辑项索引、editItem编辑项

    handleRecord开始/结束录制功能：
      点击后开始录制，返回操作步骤参数，再次点击停止录制

    handleDelete删除步骤：
      点击删除当前索引的步骤,后期应该需与scratch部分有联动

    handleImport导入接口：
      点击导入后调用getGuide根据id导入步骤列表

    handleExport保存接口：
      点击保存后调用saveGuide保存当前步骤列表（title、projectId为必填字段）

    handleClose关闭窗口：
      点击后关闭当前窗口
*/}

const EditCard = () => {
  const [draggable, setDraggable] = useState(true)
  const [insertIndex, setInsertIndex] = useState(null) // 步骤插入位置
  const [inputTitleValue, setInputTitleValue] = useState('') // title
  const [inputIdValue, setInputIdValue] = useState('') // id
  const [inputProjectIdValue, setInputProjectIdValue] = useState('') // project_id
  const [recordStatus, setRecordStatus] = useState(false) // 开始(false --> true)、停止(true --> false)录制
  const [optionList, setList] = useState([]) // 操作步骤列表
  useEffect(() => {
    if (typeof insertIndex === 'number') {
      handleRecord(insertIndex, 1)
    }
  }, [insertIndex])
  const handleCallback = (item, action, editIndex) => {
    if (item && item.action) {
      const foramt = dataFormat(item)
      if (action === 'add') {
        setList(prevArr => prevArr.concat(foramt))
      } else if (action === 'edit' && editIndex >= 0) {
        setList(prevArr => {
          prevArr[editIndex] = foramt
          return prevArr.concat([])
        })
      } else if (action === 'insert') {
        setList(prevArr => {
          prevArr.splice(editIndex + 1, 0, dataFormat(item))
          return prevArr.concat([])
        })
      }
    }
  }
  const dataFormat = step => {
    const tempParams = step.params
    let p = {}
    const tempParamsKeys = Object.keys(tempParams)
    const tempParamsValues = Object.values(tempParams)
    const keyArr = tempParamsKeys.map((item, index) => {
      if (item.includes('.')) {
        const [p0, p1] = item.split('.')
        return {
          prev: p0,
          label: p1,
          value: tempParamsValues[index]
        }
      }
      return {
        label: item,
        value: tempParamsValues[index]
      }
    })
    keyArr.forEach(key => {
      if (key.prev) {
        if (!p[key.prev]) {
          p[key.prev] = {}
        }
        if (!p[key.prev][key.label]) {
          p[key.prev][key.label] = key.value
        }
      } else {
        if (!p[key.label]) {
          p[key.label] = key.value
        }
      }
    })
    if (p.target && p.target.position !== undefined) {
      p.target.position = {
        x: '',
        y: ''
      }
      const iX = tempParamsKeys.findIndex(item => item === 'target.position.x')
      const iY = tempParamsKeys.findIndex(item => item === 'target.position.y')
      p.target.position.x = Number(tempParamsValues[iX]) || ''
      p.target.position.y = Number(tempParamsValues[iY]) || ''
    }
    step.params = p
    return step
  }
  const handleTitleChange = e => {
    setInputTitleValue(e.target.value)
  }
  const handleProjectIdChange = e => {
    setInputProjectIdValue(e.target.value)
  }
  const handleInputIdChange = e => {
    setInputIdValue(e.target.value)
  }
  const handleImport = async () => {
    const res = await getGuide({ id: inputIdValue })
    if (res) {
      setInputProjectIdValue(res.project_id)
      setInputTitleValue(res.title)
      setList(JSON.parse(res.steps))
    }
  }
  const handleExport = async () => {
    const newSteps = optionList
    const params = {
      project_id: inputProjectIdValue,
      title: inputTitleValue ? inputTitleValue : '',
      steps: JSON.stringify(newSteps)
    }
    if (inputIdValue) params.id = inputIdValue
    const res = await saveGuide(params)
  }
  const handleRecord = (index = null, status = 0) => {
    setRecordStatus(prevState => (!prevState || status))
    if (!recordStatus || status) {
      StepRecorder.startRecordAction(step => {
        const tempStep = {
          action: step.action,
          name: step.name ? step.name : '',
          success: step.success ? step.success : '',
          fail: step.fail ? step.fail : '',
          params: step.params
        }
        setList(prevState => {
          if (typeof index === 'number') {
            prevState.splice(index + 1, 0, tempStep)
            return prevState.concat([])
          }
          return prevState.concat(tempStep)
        })
        if (typeof index === 'number') {
          setInsertIndex(prev => prev + 1)
        }
      })
    } else {
      StepRecorder.stopRecordAction()
      setInsertIndex(null)
    }
  }
  const handleAddOrEdit = (action, index, item) => {
    if (item && (item.params.source || item.params.target)) {
      if (item.params.source) {
        const temp = {}
        for (let i in item.params.source) {
          temp[`source.${i}`] = item.params.source[i]
        }
        delete item.params.source
        item.params = {
          ...item.params,
          ...temp
        }
      }
      if (item.params.target) {
        const temp = {}
        for (let i in item.params.target) {
          temp[`target.${i}`] = item.params.target[i]
        }
        delete item.params.target
        item.params = {
          ...item.params,
          ...temp
        }
        if (item.params['target.position']) {
          item.params['target.position.x'] = item.params['target.position'].x || ''
          item.params['target.position.y'] = item.params['target.position'].y || ''
          delete item.params['target.position']
        }
      }
    }
    if (item) {
      const paramsDesc = steps.find(step => step.action === item.action)
      paramsDesc.params.forEach(desc => {
        if (!item.params[desc]) {
          item.params[desc] = ''
        }
      })
    }
    ModalManager.open(AddModal, {
      onConfirm: handleCallback,
      modalAction: action,
      onClose: ModalManager.pop,
      editIndex: (index || String(index) === '0') ? index : null,
      editItem: item ? item : null
    })
  }
  const handleDeletet = index => {
    setList(prevState => {
      prevState.splice(index, 1)
      return prevState.concat([])
    })
  }
  const handleClose = () => {
    const node = document.getElementById('stepEditor')
    node.parentNode.removeChild(node)
  }
  const stopDragged = () => {
    setDraggable(false)
  }
  const startDragged = () => {
    setDraggable(true)
  }
  return (
    <div>
      <Draggable disabled={!draggable} bounds={{left:-(document.body.clientWidth / 2 - 233),bottom:document.body.clientHeight / 2 - 155,top:-(document.body.clientHeight / 2 - 155),right:document.body.clientWidth / 2 - 233}} >
        <div className={styles.stepContainer}>
          <div className={styles.header}>
            <input
              placeholder='title'
              value={inputTitleValue}
              onChange={handleTitleChange}
              onFocus={stopDragged}
              onBlur={startDragged}
            />
            <input
              placeholder='projectId'
              value={inputProjectIdValue}
              onChange={handleProjectIdChange}
              onFocus={stopDragged}
              onBlur={startDragged}
            />
            <input
              placeholder='id'
              value={inputIdValue}
              onChange={handleInputIdChange}
              onFocus={stopDragged}
              onBlur={startDragged}
            />
            <button style={{ marginRight: '10px', marginLeft: '10px' }} onClick={handleImport}>导入id</button>
            <button
              className={styles.topButton}
              onClick={handleRecord}
            >{recordStatus ? '停止录制' : '开始录制'}</button>
            <button className={styles.topButton} onClick={() => handleAddOrEdit('add')}>添加</button>
          </div>
          <div className={styles.dragged}>
            <ul>
              {
                optionList.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      backgroundColor: 'pink',
                      borderBottomColor: insertIndex === index ? '#438ffa' : '#ffffff'
                    }}
                  >
                    <span>{item.action}</span>
                    <span>{item.name}</span>
                    <span>{item.params.tips ? item.params.tips : ''}</span>
                    <span>
                      <span onClick={() => handleAddOrEdit('edit', index, item)}>编辑</span>
                      <span style={{ marginLeft: '10px' }} onClick={() => setInsertIndex(index)}>插入</span>
                      <span style={{ marginLeft: '10px' }} onClick={() => handleDeletet(index)}>删除</span>
                    </span>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className={styles.footer}>
          <button className={styles.topButton} onClick={() => {
            window.StepsRuntime.runAppendSteps(optionList)
          }}>运行</button>
            <button onClick={handleExport}>保存</button>
            <button onClick={handleClose}>关闭</button>
          </div>
        </div>
      </Draggable>
    </div>
  )
}

export default EditCard
